var _g, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOceanLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 72,
    viewBox: "0 0 62 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_3746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7516 23.8418C13.9139 21.7564 17.2107 19.4328 21.0715 18.9302C32.3239 16.9374 33.1655 31.681 42.3271 32.0778C47.0337 32.1351 50.0659 28.0877 53.5319 25.1601C53.4934 23.6993 53.3293 22.2447 53.0417 20.8129C50.4693 22.3736 47.5543 23.6743 44.5004 23.7184C36.9481 23.8242 34.1415 20.0501 29.0098 15.5882C26.4051 13.4532 23.1723 12.2658 19.8265 12.2153C19.5532 12.2153 19.2799 12.2153 19.0066 12.2153C15.8724 12.1807 12.8207 13.2354 10.3569 15.2046C8.55664 16.589 6.88655 18.1939 4.93016 19.4284C4.3813 21.5346 4.10424 23.7044 4.10596 25.8832C4.10596 26.2535 4.10596 26.6283 4.13199 26.9987C6.47556 26.2731 8.70475 25.2101 10.7516 23.8418Z",
    fill: "url(#paint0_linear_106_3746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8946 31.0682C33.6557 32.867 35.0092 34.9128 36.5361 36.5926C37.6423 37.8139 38.7701 38.85 40.284 39.238C44.5742 40.1463 49.0986 35.9445 52.5039 33.158C52.92 31.7501 53.2103 30.3069 53.3715 28.846C52.2957 29.8028 51.2025 30.7772 49.9966 31.6854C45.1208 35.6094 39.0521 35.4022 34.814 30.6096C30.2548 25.2351 28.5067 19.9443 22.477 19.9443C20.8388 19.9891 19.2167 20.2864 17.6663 20.8261C13.593 22.2678 10.0273 25.4202 5.80215 26.7077C5.35227 26.8578 4.89467 26.983 4.43138 27.0824H4.40969L4.14941 27.153C4.21189 28.5974 4.40208 30.0331 4.71768 31.4429C5.00711 32.6444 5.38113 33.8232 5.83685 34.9701C7.7195 33.837 9.48502 32.4878 11.3373 31.2048C17.6966 26.5842 25.9473 24.5914 31.8946 31.0682Z",
    fill: "url(#paint1_linear_106_3746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7118 40.8517C34.5018 38.8147 32.7015 35.217 30.3374 32.6113C29.3642 31.3716 28.124 30.3755 26.7124 29.6998C25.3007 29.0241 23.7553 28.6867 22.1952 28.7138C18.7249 28.7138 15.0854 30.1908 11.9361 32.1439C10.292 33.1492 7.83675 34.6615 6.03653 35.4948H6.0105C6.42597 36.5179 6.91006 37.5107 7.45935 38.4664C9.05883 37.2662 10.7535 36.2029 12.526 35.2876C16.4301 33.2506 21.3796 32.7656 25.3965 34.8819C29.2442 36.7513 32.3372 39.8817 36.1155 41.6277C37.8393 42.4787 39.7577 42.8396 41.6671 42.6719C43.5764 42.5043 45.4055 41.8143 46.9602 40.6753C47.2812 40.4549 47.6022 40.2344 47.9145 39.9655C44.6611 41.8702 41.1561 42.8666 37.7118 40.8517Z",
    fill: "url(#paint2_linear_106_3746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0299 39.529C27.2356 40.4637 29.847 42.7784 32.7317 44.1672C36.5404 46.0014 41.0952 46.4114 45.047 44.8418L45.5241 44.4009C44.3573 44.8957 43.1165 45.1863 41.8543 45.2607C36.7226 45.609 33.1785 42.871 29.7082 40.1374C26.4374 37.5494 23.2447 34.9613 18.8635 34.9877H18.5251C14.621 34.9877 10.9728 36.9101 7.60229 38.8103C8.35174 40.0843 9.21268 41.2869 10.1747 42.4037C14.4779 39.1807 18.6813 37.9947 24.0299 39.529Z",
    fill: "url(#paint3_linear_106_3746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.479 41.2309C21.8306 40.6527 20.0997 40.3547 18.3559 40.3491C17.0025 40.3411 15.657 40.5601 14.3737 40.9972C13.0479 41.4995 11.7591 42.0977 10.5173 42.7873C12.836 45.3843 15.6646 47.4583 18.8207 48.8754C21.9768 50.2925 25.3902 51.0212 28.8406 51.0144C32.633 51.0201 36.375 50.1311 39.7721 48.4175C36.9475 48.3588 34.1755 47.6295 31.6776 46.288C28.7582 44.7448 26.5111 42.3464 23.479 41.2309Z",
    fill: "url(#paint4_linear_106_3746)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50685 58.7004C8.70437 58.7004 11.0704 60.9236 11.0704 64.0016C11.0704 67.0797 8.69303 69.2002 5.50685 69.2002C2.36602 69.2002 0 67.0577 0 64.0016C0 60.9456 2.36602 58.7004 5.50685 58.7004ZM5.50685 67.7033C7.81995 67.7033 9.36958 66.2102 9.36958 63.987C9.36958 61.7637 7.81995 60.1935 5.50685 60.1935C3.2391 60.1935 1.72727 61.7711 1.72727 63.987C1.72727 66.2029 3.26934 67.7033 5.50685 67.7033Z",
    fill: "#014C8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9911 68.5213C21.9349 68.9999 20.7772 69.2299 19.6122 69.1927C16.0367 69.1927 13.5913 67.0575 13.5913 63.9428C13.5913 60.8281 16.0216 58.7002 19.5895 58.7002C20.7122 58.6917 21.8249 58.9065 22.8588 59.3312L22.6963 60.7987C21.7178 60.3794 20.6591 60.1656 19.5895 60.1714C17.0572 60.1714 15.3413 61.6865 15.3413 63.9098C15.3413 66.133 17.1517 67.6702 19.7898 67.6702C20.8181 67.6925 21.8369 67.4748 22.7606 67.0355L22.9911 68.5213Z",
    fill: "#014C8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7516 69.0496H25.9619V58.8506H33.5891V60.2851H27.5871V63.0953H32.7765V64.5298H27.5871V67.6151H33.7516V69.0496Z",
    fill: "#014C8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5597 66.9218H38.2683L37.4179 69.0496H35.6755L40.0107 58.8506H41.7871L46.1299 69.0496H44.395L43.5597 66.9218ZM38.7105 65.6084H43.0873L40.9216 60.6153L38.7105 65.6084Z",
    fill: "#014C8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3364 69.0496H48.7112V58.8506H50.3364L57.0451 66.6246V58.8506H58.6666V69.0496H57.0262L50.3364 61.3527V69.0496Z",
    fill: "#014C8A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_3746",
    x1: 4.11464,
    y1: 22.1355,
    x2: 53.5492,
    y2: 22.1355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ED4D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_3746",
    x1: 4.14941,
    y1: 29.6617,
    x2: 53.3888,
    y2: 29.6617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00ABB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_3746",
    x1: 5.98881,
    y1: 35.7064,
    x2: 47.8842,
    y2: 35.7064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FC8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_3746",
    x1: 7.62398,
    y1: 40.402,
    x2: 45.5241,
    y2: 40.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_106_3746",
    x1: 10.5173,
    y1: 45.6707,
    x2: 39.7721,
    y2: 45.6707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3564A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004C8F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_3746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.5873,
    height: 50.4,
    fill: "white",
    transform: "translate(4.19019 0.738739)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOceanLogo);
export default __webpack_public_path__ + "static/media/ocean-logo.974392170a773dc6171018f7104db8b6.svg";
export { ForwardRef as ReactComponent };